import type { ScopedMutator } from 'swr/_internal'

/**
 * Clears the SWR cache entry for a questionnaire careplan activity.
 *
 * useHealthblocksSWR uses array-based SWR keys: [url, projectId, actorId].
 * This matcher targets the first element (the URL) to find the right entry.
 */
export function clearQuestionnaireActivityCache(mutate: ScopedMutator, activityId: string | number) {
  // SWR's global mutate iterates all cache keys, which includes plain string
  // keys from other hooks. The Array.isArray guard ensures we only match
  // healthblocks-style array keys and don't accidentally match or error on
  // string keys from unrelated SWR hooks.
  void mutate(
    (key) =>
      Array.isArray(key) &&
      typeof key[0] === 'string' &&
      key[0].includes(`/views/patient/questionnaire-activity/${activityId}`),
    undefined,
    { revalidate: false },
  )
}
